import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const ACPSSection: FunctionComponent = () => {
	const {t} = useTranslation();
	return (
		<LandingIllustrationSection
			imagePosition="right"
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'featureslandingpage_title_fairpayforeverytrackplayed_standalone-web',
							{
								ns: 'features',
							},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'featureslandingpage_text_acpsmeansstreamsupportsartist_standalone-web',
							{
								ns: 'features',
							},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					h={{base: '310px', md: '100%'}}
					quality={90}
					sizes={{base: '100vw', md: '50vw'}}
					alt={'acps'}
					src="137353b7b5bebeb0bc329aa5109ff2ae.jpg"
					aspectRatio="456/412"
					width={{base: '100%', md: '70%'}}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{
						eventaction: 'discover',
						eventlabel: 'artist-remuneration',
					}}
					href="/artist-remuneration"
				>
					{t('generic_action_learnmore_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
		/>
	);
};
